import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatteryUnknownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_unknown"}/>
}
